export function getAllowSelectedBlocks(model) {
    const result = [];
    const blocks = model.children.slice();
    const dfs = (blocks) => {
        for (const block of blocks) {
            if (block.flavour !== 'affine:note') {
                result.push(block);
            }
            block.children.length && dfs(block.children);
        }
    };
    dfs(blocks);
    return result;
}
//# sourceMappingURL=utils.js.map